"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_ORGANIZATIONS = exports.AVAILABLE_ROLES = exports.MOCK_USER_LIST = exports.DEMO_USER = exports.MOCK_USER = void 0;
exports.MOCK_USER = {
    id: 1,
    userId: "B7C8FEC9-D377-4FA1-83CB-AE4B9A2D64B8",
    username: "cmx_username",
    password: undefined,
    confirmPassword: null,
    firstName: "codametrix",
    lastName: "admin",
    active: true,
    ignoreLockout: false,
    locked: false,
    passwordExpired: null,
    forcePasswordChange: false,
    entityId: null,
    entityType: null,
    roles: [
        {
            tenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            organizationName: "CodaMetrix",
            roles: [
                {
                    id: 1,
                    roleName: "administrator",
                    roleDescription: "Administrator",
                    primaryRole: null
                }
            ],
            displayName: ""
        }
    ]
};
exports.DEMO_USER = __assign(__assign({}, exports.MOCK_USER), { roles: [
        {
            tenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            organizationName: "CodaMetrix",
            roles: [
                {
                    id: 7,
                    roleName: "demo",
                    roleDescription: "Demo",
                    primaryRole: null
                }
            ],
            displayName: ""
        }
    ] });
exports.MOCK_USER_LIST = [exports.MOCK_USER];
exports.AVAILABLE_ROLES = [
    {
        id: 2,
        roleName: "administrator",
        roleDescription: "Administrator",
        primaryRole: null
    },
    {
        id: 4,
        roleName: "coordinator",
        roleDescription: "Coordinator",
        primaryRole: null
    },
    {
        id: 6,
        roleName: "external_system",
        roleDescription: "External System",
        primaryRole: null
    },
    {
        id: 1,
        roleName: "super_admin",
        roleDescription: "Super Admin",
        primaryRole: null
    },
    { id: 5, roleName: "system", roleDescription: "System", primaryRole: null },
    {
        id: 3,
        roleName: "user_manager",
        roleDescription: "User Manager",
        primaryRole: null
    }
];
exports.AVAILABLE_ORGANIZATIONS = {
    id: 1,
    version: 0,
    createdDate: 1568836255581,
    updateDate: null,
    organizationName: "CodaMetrix",
    organizationCode: "CMX",
    tenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    organizationType: "BUSINESS",
    address1: null,
    address2: null,
    city: "Boston",
    state: "MA",
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: null,
    parentLevel: 0,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: null,
    defaultRelationship: null,
    serviceLines: [],
    children: [
        {
            id: 4,
            version: 1,
            createdDate: 1568836255588,
            updateDate: null,
            organizationName: "MD Anderson Cancer Center",
            organizationCode: "MDACC",
            tenantId: "61494C60-DBAD-4C4E-B626-D6734D38357B",
            organizationType: "HEALTH_SYSTEM",
            address1: null,
            address2: null,
            city: null,
            state: null,
            zipCode: null,
            phone: null,
            contactName: null,
            parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            parentLevel: 1,
            requireDedicatedSiteHeader: null,
            dedicatedSiteHeader: null,
            parentId: 1,
            defaultRelationship: null,
            serviceLines: [],
            children: [
                {
                    id: 22,
                    version: 1,
                    createdDate: 1568836255633,
                    updateDate: null,
                    organizationName: "MD Anderson Hospital",
                    organizationCode: "MDA",
                    tenantId: "5577D12B-70AE-4D4F-B57C-53262F5DA442",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "61494C60-DBAD-4C4E-B626-D6734D38357B",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 4,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                }
            ],
            relatedOrganizations: []
        },
        {
            id: 2,
            version: 1,
            createdDate: 1568836255583,
            updateDate: null,
            organizationName: "Partners Health System",
            organizationCode: "PHS",
            tenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
            organizationType: "HEALTH_SYSTEM",
            address1: null,
            address2: null,
            city: null,
            state: null,
            zipCode: null,
            phone: null,
            contactName: null,
            parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            parentLevel: 1,
            requireDedicatedSiteHeader: null,
            dedicatedSiteHeader: null,
            parentId: 1,
            defaultRelationship: null,
            serviceLines: [],
            children: [
                {
                    id: 16,
                    version: 1,
                    createdDate: 1568836255617,
                    updateDate: null,
                    organizationName: "Dana Farber Cancer Institute",
                    organizationCode: "DFCI",
                    tenantId: "54EF0CD8-212C-4649-B84A-DA2BA052695C",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 18,
                    version: 1,
                    createdDate: 1568836255625,
                    updateDate: null,
                    organizationName: "Brigham & Women's Physicians Organization",
                    organizationCode: "BWPO",
                    tenantId: "9B609301-EE7B-4B06-83C8-B509A470C30D",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 7,
                    version: 1,
                    createdDate: 1568836255596,
                    updateDate: null,
                    organizationName: "Partners Urgent Care",
                    organizationCode: "PUC",
                    tenantId: "F006F69B-44C0-40A5-B8C1-56E3A941EF5E",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 14,
                    version: 1,
                    createdDate: 1568836255614,
                    updateDate: null,
                    organizationName: "Brigham & Women's Hospital",
                    organizationCode: "BWH",
                    tenantId: "ABCCCEEA-6193-4575-B90D-C7E657C0B922",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 6,
                    version: 1,
                    createdDate: 1568836255592,
                    updateDate: null,
                    organizationName: "Pentucket Medical Associates",
                    organizationCode: "PMA",
                    tenantId: "44DF939F-C08E-45EC-A1E0-811378DBABB3",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 8,
                    version: 1,
                    createdDate: 1568836255599,
                    updateDate: null,
                    organizationName: "Martha's Vineyard Hospital",
                    organizationCode: "MVH",
                    tenantId: "D7FE4491-5693-424F-B857-5DDC16788652",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 5,
                    version: 1,
                    createdDate: 1568836255590,
                    updateDate: null,
                    organizationName: "Massachusetts General Hospital",
                    organizationCode: "MGH",
                    tenantId: "C89EA023-2426-4517-9F23-D308925DD65D",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 13,
                    version: 1,
                    createdDate: 1568836255612,
                    updateDate: null,
                    organizationName: "Spaulding Rehab Hospital",
                    organizationCode: "SRH",
                    tenantId: "96780424-CA72-4DED-9BDF-D844719483D5",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 15,
                    version: 1,
                    createdDate: 1568836255615,
                    updateDate: null,
                    organizationName: "Faulkner Hospital",
                    organizationCode: "FH",
                    tenantId: "7D1BDE4E-340C-4A5F-8F02-593DEF86AE7F",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 10,
                    version: 1,
                    createdDate: 1568836255604,
                    updateDate: null,
                    organizationName: "North Shore Medical Center",
                    organizationCode: "NSMC",
                    tenantId: "BB1EA38B-7AB4-4498-A0B2-E2FD3CB029A4",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 11,
                    version: 1,
                    createdDate: 1568836255606,
                    updateDate: null,
                    organizationName: "Newton Wellesley Hospital",
                    organizationCode: "NWH",
                    tenantId: "F88E0710-AA53-42D8-A744-4F1272669AB4",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 12,
                    version: 1,
                    createdDate: 1568836255609,
                    updateDate: null,
                    organizationName: "Nantucket Cottage Hospital",
                    organizationCode: "NCH",
                    tenantId: "77CE9F7C-1C67-4575-B28B-81D9BCAF59EC",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 17,
                    version: 1,
                    createdDate: 1568836255623,
                    updateDate: null,
                    organizationName: "Mass General Physicians Organization",
                    organizationCode: "MGPO",
                    tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 9,
                    version: 1,
                    createdDate: 1568836255602,
                    updateDate: null,
                    organizationName: "Cooley Dickinson Hospital",
                    organizationCode: "CDH",
                    tenantId: "369A206E-199F-490F-9669-25CDFBAEAA9B",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                }
            ],
            relatedOrganizations: [
                {
                    id: 18,
                    version: 1,
                    createdDate: 1568836255625,
                    updateDate: null,
                    organizationName: "Brigham & Women's Physicians Organization",
                    organizationCode: "BWPO",
                    tenantId: "9B609301-EE7B-4B06-83C8-B509A470C30D",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 17,
                    version: 1,
                    createdDate: 1568836255623,
                    updateDate: null,
                    organizationName: "Mass General Physicians Organization",
                    organizationCode: "MGPO",
                    tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 2,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                }
            ]
        },
        {
            id: 3,
            version: 1,
            createdDate: 1568836255585,
            updateDate: null,
            organizationName: "Colorado Health System",
            organizationCode: "CHS",
            tenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
            organizationType: "HEALTH_SYSTEM",
            address1: null,
            address2: null,
            city: null,
            state: null,
            zipCode: null,
            phone: null,
            contactName: null,
            parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            parentLevel: 1,
            requireDedicatedSiteHeader: null,
            dedicatedSiteHeader: null,
            parentId: 1,
            defaultRelationship: null,
            serviceLines: [],
            children: [
                {
                    id: 21,
                    version: 1,
                    createdDate: 1568836255631,
                    updateDate: null,
                    organizationName: "CU Medicine",
                    organizationCode: "CUMED",
                    tenantId: "207267E5-F5E6-418C-B7A8-AB19B1D22FD4",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 3,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 19,
                    version: 1,
                    createdDate: 1568836255627,
                    updateDate: null,
                    organizationName: "University of Colorado Hospital",
                    organizationCode: "UCH",
                    tenantId: "C00F807A-EFD6-4839-B6C7-EA26B492C1FA",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 3,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                },
                {
                    id: 20,
                    version: 1,
                    createdDate: 1568836255628,
                    updateDate: null,
                    organizationName: "Children's Hospital Colorado",
                    organizationCode: "CHCO",
                    tenantId: "17B740ED-613A-41B9-83CF-C9B85AFA95B3",
                    organizationType: "HOSPITAL",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 3,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                }
            ],
            relatedOrganizations: [
                {
                    id: 21,
                    version: 1,
                    createdDate: 1568836255631,
                    updateDate: null,
                    organizationName: "CU Medicine",
                    organizationCode: "CUMED",
                    tenantId: "207267E5-F5E6-418C-B7A8-AB19B1D22FD4",
                    organizationType: "PHYSICIAN_ORGANIZATION",
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    phone: null,
                    contactName: null,
                    parentTenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
                    parentLevel: 2,
                    requireDedicatedSiteHeader: null,
                    dedicatedSiteHeader: null,
                    parentId: 3,
                    defaultRelationship: null,
                    serviceLines: [],
                    children: [],
                    relatedOrganizations: []
                }
            ]
        }
    ],
    relatedOrganizations: []
};
//# sourceMappingURL=user.js.map